export default function UserService(
    $http,
    API_SERVER,
    $q,
    Log,
    DummyApi,
    UserJar,
    UserModel,
    CompanyModel,
    PspModel
) {
    var fn = this;

    fn.userRoles = null;
    /**
     * API V3
     */

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetUser
     * @param {int} id
     */
    fn.get = (id) => {
        // Endpoint:
        const endpoint = `/users/${id}`;

        // TO DO ::: MEDIUM ::: This endpoint should NOT be allowed by this client. use identity server scope
        // solution : /users/me

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url, { cache: false }).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_CreateUser
     * @param {obj} user
     */
    fn.create = (user, company) => {
        const preparedUser = adhereUserModel(
            angular.copy(user), // data
            UserModel // model
        );

        const preparedCompany = company
            ? adhereCompanyModel(
                  angular.copy(company), // data
                  CompanyModel // model
              )
            : null;

        // Endpoint:
        const endpoint = `/users`;

        const params = `?notify_email=true`;

        const url = API_SERVER + endpoint + params;

        const payload = { user: preparedUser, company: preparedCompany };

        const req = {
            method: "POST",
            url: url,
            headers: {
                endpointType: "noTokenRequired", // used by interceptor to skip access token
            },
            data: payload,
        };

        Log.endpoint(endpoint, url);

        /**
         * Easy testing
         */
        // return $q.reject("user could not be created");
        // return $q.resolve(payload);

        return $http(req).then(
            (res) => {
                return res.data;
            },
            (err) => {
                // if (err.status == 400) {
                //     err.data.forEach((res) => {
                //         console.error(res);
                //     });
                // }

                return $q.reject(err);
            }
        );
    };

    fn.update = function (user) {
        // Endpoint:
        const endpoint = `/users/${user.id}`;

        Log.obj("user", user);

        const preparedUser = adhereUserModel(
            angular.copy(user), // update
            UserModel // model
        );

        Log.obj("preparedUser", preparedUser);

        const url = API_SERVER + endpoint;

        // preparedUser.primaryRole = 4;

        Log.endpoint(endpoint, url);

        return $http.put(url, preparedUser).then(
            (res) => {
                return res.data;
            },
            (err) => {
                if (err.status == 400) {
                    err.data.forEach((res) => {
                        console.error(res);
                    });
                }

                return $q.reject(err);
            }
        );
    };

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetUserRoles
     * @param {int} id
     */
    fn.getUserRoles = (id) => {
        // Endpoint:
        const endpoint = `/users/${id}/roles`;

        // TO DO ::: MEDIUM :::  This endpoint should NOT be allowed by this client. use identity server scope
        // solution /users/me/roles
        // TO DO ::: MEDIUM ::: Kan en bruger kun have 1 rolle her, for så er /roles kaldet unødvendigt ?

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url, { cache: true }).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetUserBookingPeriods
     * @param {int} id
     */
    fn.getBookingPeriods = (id, start, end, locationId, activityId) => {
        // Endpoint:
        const endpoint = `/users/${id}/bookingperiods`;

        const params = `?start=${start}&end=${end}&location_id=${locationId}&activity_id=${activityId}&expand=activity,resource`;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        return $http.get(url, { cache: true }).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetUserBookings
     * @param {int} id
     */

    fn.getBookings = (id) => {
        // Endpoint:
        const endpoint = `/users/${id}/bookings`;

        const params = `?page=1&pageSize=100&expand=bookingperiods`;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        return $http.get(url, { cache: false }).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger -https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetUserLocations
     * @param {int} id
     */
    fn.getLocations = (id) => {
        // Endpoint:
        const endpoint = `/users/${id}/locations`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url, { cache: true }).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger -https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetEmailCheck
     * @param {string} email
     * [unauthorized]
     */
    fn.emailCheck = (email) => {
        // Endpoint:
        const endpoint = `/users/email_check`;

        const params = `?email=${email}`;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        const headers = {
            endpointType: "noTokenRequired", // used by interceptor to skip access token
        };

        return $http.get(url, { headers: headers }).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger -https://apiv3.projektbookbyen.dk/index.html#/Users/Users_GetUsernameCheck
     * @param {string} username
     * [unauthorized]
     */
    fn.usernameCheck = (username) => {
        // Endpoint:
        const endpoint = `/users/username_check`;

        const params = `?username=${username}`;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        const headers = {
            endpointType: "noTokenRequired", // used by interceptor to skip access token
        };

        return $http.get(url, { headers: headers }).then((res) => {
            return res.data;
        });
    };

    /**
     *
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_PutChangePassword
     * @param {int} userId
     * @param {string} newPassword
     */
    fn.changePassword = (id, newPassword) => {
        // Request body
        const body = {
            password: newPassword,
        };

        // Endpoint:
        const endpoint = `/users/${id}/change_password`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.put(url, body).then((res) => {
            return res.data;
        });
    };

    /**
     *
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_ResetPasswordRequest
     * @param {string} email
     * [unauthorized]
     */
    fn.resetPasswordRequest = (email) => {
        // Endpoint:
        const endpoint = `/users/reset_password_request?email=${email}`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        const req = {
            method: "GET",
            url: url,
            headers: {
                endpointType: "noTokenRequired", // used by interceptor to skip access token
            },
        };

        return $http(req).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_VerifyUid
     * [unauthorized]
     * @param {string} email
     *
     */
    fn.verifyUid = (uid) => {
        // Endpoint:
        const endpoint = `/users/verify_uid`;

        const params = `?uid=${uid}`;

        const url = API_SERVER + endpoint + params;

        const req = {
            method: "GET",
            url: url,
            headers: {
                endpointType: "noTokenRequired", // used by interceptor to skip access token
            },
        };

        Log.endpoint(endpoint, url);

        return $http(req).then((res) => {
            return res.data;
        });
    };

    /**
     * Swagger - https://apiv3.projektbookbyen.dk/index.html#/Users/Users_VerifyUid
     * [unauthorized]
     * @param {string} email
     *
     */
    // fn.createCompanyInfo = (id, company) => {
    //     preparedCompany = adhereCompanyModel(company);

    //     const payload = { company: preparedCompany };

    //     // Endpoint:
    //     const endpoint = `/users/${id}/companyinfo`;

    //     const url = API_SERVER + endpoint;

    //     Log.endpoint(endpoint, url);

    //     return $http.post(url, payload).then((res) => {
    //         return res.data;
    //     });
    // };

    fn.getCompanyInfo = (id) => {
        // Endpoint:
        const endpoint = `/users/${id}/companyinfo`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url).then((res) => {
            return res.data;
        });
    };

    fn.updateCompanyInfo = (id, company) => {
        const preparedCompany = adhereCompanyModel(company, CompanyModel);

        const payload = preparedCompany; // { company: preparedCompany };

        // Endpoint:
        const endpoint = `/users/${id}/companyinfo`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.put(url, payload).then((res) => {
            return res.data;
        });
    };

    fn.getPsp = (id) => {
        // Endpoint:
        const endpoint = `/users/${id}/psp`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.get(url).then((res) => {
            return res.data;
        });
    };

    fn.updatePsp = (id, psp) => {
        const preparedPsp = adherePspModel(psp, PspModel);

        const payload = preparedPsp;

        // Endpoint:
        const endpoint = `/users/${id}/psp`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.put(url, payload).then((res) => {
            return res.data;
        });
    };

    fn.validatePSP = (psp) => {
        const payload = {
            psp: psp,
        };

        // Endpoint:
        const endpoint = `/payments/psp:validate`;

        const url = API_SERVER + endpoint;

        Log.endpoint(endpoint, url);

        return $http.post(url, payload).then((res) => {
            return res.data;
        });
    };

    /**
     *
     * Swagger - https://apiv3.bookbyen.dk/index.html#/Users/Users_ResetPassword
     * [unauthorized]
     *
     * @param {string} email
     */
    fn.resetPassword = (uid, newPassword) => {
        const reqBody = {
            uid: uid,
            password: newPassword,
        };

        // Endpoint:
        const endpoint = `/users/reset_password`;

        const url = API_SERVER + endpoint;

        const req = {
            method: "POST",
            url: url,
            headers: {
                endpointType: "noTokenRequired", // used by interceptor to skip access token
            },
            data: reqBody,
        };

        Log.endpoint(endpoint, url);

        return $http(req).then((res) => {
            return res.data;
        });
    };

    /**
     * adherePspModel
     */
    const adherePspModel = (source, model) => {
        return adhereModel(source, model);
    };

    /**
     * adhereCompanyModel
     */
    const adhereCompanyModel = (source, model) => {
        return adhereModel(source, model);
    };

    /**
     *
     * @param {obj} source // the user to update
     * @param {obj} model // the model to adhere
     */
    const adhereUserModel = (source, model) => {
        /*** prop {displayName} to prop {note} */
        /**
         * displayName (infotavle navn)
         */

        if (!source.displayName) {
            /**
             * Business Logic ::: if no displayName copy user.name
             */
            source.displayName = source.name;
        }

        /**
         * Manually convert props which does not have the same prop type as model
         */
        // source.primaryRole = Number(source.primaryRole);
        // source.id = source.id.toString(); //from number
        source.mobile = source.mobile != null ? source.mobile.toString() : ""; //from number
        source.secondaryEmail = source.secondaryEmail // TO DO ::: LOW ::: why is this neccesary ??
            ? source.secondaryEmail
            : ""; // or convert null to string

        return adhereModel(source, model);
    };

    const adhereModel = (source, model) => {
        let target = {};

        if (!model) {
            console.warn("model not stored");
        }

        Object.keys(source).forEach((key) => {
            /**
             * careful here .. foreach key typeof always = string weird issue
             * therefore use source[key]
             */
            if (model.hasOwnProperty(key)) {
                if (typeof source[key] !== typeof model[key]) {
                    console.error(
                        " = model : " +
                            typeof source[key] +
                            " = source : " +
                            typeof model[key] +
                            " ---- " +
                            key +
                            " --- property must have same type as model"
                    );
                }
                target[key] = source[key];
            } else {
                console.warn(
                    key +
                        " is not a model prop, and was removed in API:updateUser"
                );
            }
        });

        return target;
    };

    return fn;
}
